import React from 'react';
import { ActionIcon, Group, Kbd, Text, Tooltip, UnstyledButton, rem } from '@mantine/core';
import { spotlightHandle } from '@/lib/spotlight/spotlight.store';
import { IconSearch } from '@tabler/icons-react';
import { TOUCH_TARGET, useIsMac, useIsTouch } from '@/hooks/use.responsive';

type Props = {
    iconOnly?: boolean;
};

const ShellSearchTrigger: React.FC<Props> = ({ iconOnly = false }) => {
    const isMac = useIsMac();
    const isTouch = useIsTouch();

    if (iconOnly) {
        return (
            <Tooltip label="Cerca o vai a…">
                <ActionIcon
                    size={isTouch ? TOUCH_TARGET : 'lg'}
                    variant="default"
                    onClick={spotlightHandle.open}
                    aria-label="Apri la ricerca"
                >
                    <IconSearch size={19} stroke={1.7} />
                </ActionIcon>
            </Tooltip>
        );
    }

    return (
        <UnstyledButton
            onClick={spotlightHandle.open}
            aria-label="Apri la ricerca e la navigazione rapida"
            aria-keyshortcuts={isMac ? 'Meta+K' : 'Control+K'}
            style={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                maxWidth: rem(560),
                height: rem(38),
                paddingInline: rem(12),
                gap: rem(10),
                borderRadius: 'var(--mantine-radius-md)',
                border: '1px solid var(--bd-border)',
                backgroundColor: 'var(--bd-surface-sunken)',
                color: 'var(--mantine-color-dimmed)',
                transition: 'border-color 160ms ease, background-color 160ms ease',
            }}
            onMouseEnter={(event) => { event.currentTarget.style.borderColor = 'var(--bd-border-strong)'; }}
            onMouseLeave={(event) => { event.currentTarget.style.borderColor = 'var(--bd-border)'; }}
        >
            <IconSearch size={17} stroke={1.8} style={{ flexShrink: 0 }} />
            <Text size="sm" style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                Cerca o vai a…
            </Text>
            <Group gap={4} wrap="nowrap" visibleFrom="sm" aria-hidden>
                <Kbd size="xs">{isMac ? '⌘' : 'Ctrl'}</Kbd>
                <Kbd size="xs">K</Kbd>
            </Group>
        </UnstyledButton>
    );
};

export default ShellSearchTrigger;
